import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import { Spin, Modal } from 'antd'
import {withTranslation} from 'react-i18next'
import PersonalPhoneSearchResult from './PersonalPhoneSearchResult'
@inject('marketingSmsManagementStore')
@observer
class PersonalPhone extends Component {
  state = {
  }

  formRef = React.createRef()

  componentDidMount() {
  }
  render() {
    const { marketingSmsManagementStore, addModalVisible, handleCancel, sourceType, t } = this.props
    const { isFetchingPersonalPhone, phoneCount, smsCount } = marketingSmsManagementStore
    return (
      <Modal
        title={`${t(`marketingManagement.personalizedSMS`)}${t(`marketingManagement.view`)}`}
        closable={true}
        visible={addModalVisible}
        onCancel={handleCancel}
        maskClosable={false}
        destroyOnClose={true}
        width={'60%'}
        centered
        footer={false}
        className='shortLinkModel'
      >
        <Spin spinning={isFetchingPersonalPhone}>
          <div>共 <span style={{color: '#ff5200', fontWeight: 'bold'}}>{phoneCount}</span> 个号码， 消耗短信 <span style={{color: '#ff5200', fontWeight: 'bold'}}>{smsCount}</span> 条</div>
          <PersonalPhoneSearchResult sourceType={sourceType} handleCancel={handleCancel} />
        </Spin>
      </Modal>
    )
  }
}

export default withTranslation()(PersonalPhone)
